import React, { useState, useRef } from "react";
import emailjs from "emailjs-com";
import SimpleReactValidator from "simple-react-validator";

const ContactForm = () => {
  const formRef = useRef();
  const [forms, setForms] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });

  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
    })
  );

  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    validator.showMessages();
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      emailjs
        .sendForm(
          "service_smkrlgk", // Replace with your EmailJS service ID
          "template_z3tdogg", // Replace with your EmailJS template ID
          formRef.current,
          "ZFEmMzIz4FfYa0xrm" // Replace with your EmailJS public key
        )
        .then(
          () => {
            alert("Message sent successfully!");
            setForms({
              name: "",
              email: "",
              subject: "",
              phone: "",
              message: "",
            });
          },
          (error) => {
            console.error("EmailJS Error:", error.text);
            alert("Failed to send message.");
          }
        );
      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  return (
    <form ref={formRef} onSubmit={submitHandler}>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="input_title" htmlFor="input_name">
              Full Name
            </label>
            <input
              value={forms.name}
              type="text"
              name="name"
              className="form-control"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Emmanuel Braxo"
            />
            {validator.message("name", forms.name, "required|alpha_space")}
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="input_title" htmlFor="input_email">
              Your Email
            </label>
            <input
              value={forms.email}
              type="email"
              name="email"
              className="form-control"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Braxo@example.com"
            />
            {validator.message("email", forms.email, "required|email")}
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="input_title" htmlFor="input_phone">
              Your Phone
            </label>
            <input
              value={forms.phone}
              type="tel"
              name="phone"
              className="form-control"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="+254 700 000 000"
            />
            {validator.message("phone", forms.phone, "required")}
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="input_title" htmlFor="input_textarea">
              Message
            </label>
            <textarea
              onBlur={changeHandler}
              onChange={changeHandler}
              value={forms.message}
              name="message"
              className="form-control"
              placeholder="How can we help you?"
            ></textarea>
            {validator.message("message", forms.message, "required")}
          </div>
          <button type="submit" className="btn btn-primary">
            <span className="btn_label" data-text="Send Message">
              Send Message
            </span>
            <span className="btn_icon">
              <i className="fa-solid fa-arrow-up-right"></i>
            </span>
          </button>
        </div>
      </div>
    </form>
  );
};

export default ContactForm;
